import React from 'react';
import { AnimatedSection } from './AnimatedSection';
export function ProblemSection() {
  return <AnimatedSection className="py-16 md:py-24 px-4 sm:px-6" data-id="element-138">
      <div className="max-w-3xl mx-auto" data-id="element-139">
        <div className="glass-card rounded-2xl p-8 md:p-12" data-id="element-140">
          <h2 className="font-display text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-8 text-center" data-id="element-141">
            ¿Te suena <span className="text-[#D4A853]" data-id="element-142">familiar</span>?
          </h2>

          <div className="space-y-6 text-gray-300 text-base md:text-lg leading-relaxed" data-id="element-143">
            <p data-id="element-144">
              Has intentado de todo: infusiones de manzanilla, apagar el
              teléfono, incluso suplementos de magnesio baratos de farmacia que
              solo te causaron malestar estomacal sin darte un minuto de
              descanso real.
            </p>
            <p data-id="element-145">
              El ejercicio intenso y el ritmo de vida actual agotan tus reservas
              de magnesio, el mineral encargado de{' '}
              <strong className="text-[#4ECDC4]" data-id="element-146">"apagar" la adrenalina</strong>
              . Sin él, tu cerebro permanece en modo alerta, impidiéndote
              alcanzar el sueño REM, ese donde tu cuerpo realmente se repara y
              tus hormonas se equilibran.
            </p>
          </div>
        </div>
      </div>
    </AnimatedSection>;
}